import React from 'react';

import {ObservationList} from '../../components/ObservationList';

export const Observations: React.FC = () => {
  return (
    <ObservationList />
  );
};
